<template>
  <section id="impress" class="white">
    <v-container grid-list-xl>
      <v-layout row wrap justify-center class="my-5">
        <v-flex xs12 class="text-xs-center">
          <div class="display-1 v-heading mb-3 font-weight-light">Tierschutzverein Robin Hood</div>
        </v-flex>
        <v-flex xs12>
          <v-card class="elevation-0 transparent">
            <v-card-text>
              <p>
                <b>Spendenkonto Österreich:</b>
                Tierschutzverein Robin Hood<br/>
                Sparkasse Niederösterreich Mitte West<br/>
                IBAN: AT63 2025 6000 0094 9875<br/>
                BIC: SPSPAT21XXX<br/>
              </p>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 class="text-xs-center">
          <a href="http://robinhood-tierschutz.at/impressum/" target="_blank">Impressum</a> |&nbsp;<a
          href="http://robinhood-tierschutz.at/datenschutz/" target="_blank">Datenschutz</a><br>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
  export default {
    name: 'GuestInfo',
  };
</script>

<style scoped>

</style>
